import iconLine from "@/assets/img/new/icon-line.svg";
import iconHeart from "@/assets/img/new/icon-heart.svg";
import iconStar from "@/assets/img/new/icon-star.svg";
import CardGridSection from "@/components/common/CardGridSection";

import NavbarFooter from "@/components/headtail/Navbar/NavbarFooter";


export default function SolutionsPage() {
  return (
    <>
      <section className="fp-container-fluid header__common header--solutions">
        <div className="mobile-content"></div>
        <div className="fp-container">
          <div className="fp-row">
            <div className="cell-12 cell-lg-6 header-content">
              <h1>Streamlining Travel Document Verification with Unmatched Precision and Speed!
              </h1>
              <p>In the dynamic realm of air travel, where passenger expectations evolve by the day, embracing
                innovative solutions is not just a choice; it's a necessity. FurtherPass stands as a beacon of
                transformation, redefining the way airlines and airports engage with passengers and elevate their
                operations.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="fp-container-fluid solutions__a">
        <div className="fp-container">
          <div className="fp-row">
            <div className="cell-lg-4">
              <div className="fp-card">
                <h3>The Challenge</h3>
                <p>Airline and airport professionals are acutely aware of the hurdles they face daily. Managing
                  immigration requirements, streamlining passenger experiences, and ensuring compliance are just a few
                  of
                  the complex tasks that demand precision. Traditional methods have often led to queues, delays, and
                  passenger dissatisfaction.</p>
              </div>
            </div>
            <div className="cell-lg-4">
              <div className="fp-card">
                <h3>The FurtherPass Solution</h3>
                <p>At FurtherPass, we've embarked on a mission to simplify these complexities, offering a comprehensive
                  platform that revolutionizes travel document control and passenger experiences.</p>
              </div>
            </div>
            <div className="cell-lg-4">
              <div className="fp-card">
                <h3>Empowering Airlines and Airports</h3>
                <p>Our platform provides a seamless solution that empowers airlines and airports to overcome these
                  challenges. FurtherPass transforms travel document verification into an efficient, secure, and
                  hassle-free process.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CardGridSection
        sectionClass="fp-container-fluid solutions__b"
        cards={[
          {
            icon: iconLine,
            alt: "icon-line",
            title: "Efficiency Redefined",
            description: "Say goodbye to long queues and cumbersome check-in procedures. Our technology simplifies the passenger experience, allowing your team to focus on what truly matters – delivering exceptional service.",
          },
          {
            icon: iconHeart,
            alt: "icon-heart",
            title: "Enhanced Passenger Satisfaction",
            description: "Happy passengers are loyal passengers. By using FurtherPass, you not only improve your operations but also enhance passenger satisfaction, leading to increased loyalty and positive word-of-mouth.",
          },
          {
            icon: iconStar,
            alt: "icon-star",
            title: "Operational Excellence",
            description: "We empower your team with tools that enhance their capabilities, making their roles more efficient and rewarding. From check-in agents to ground staff, FurtherPass is your partner in achieving operational excellence.",
          },
        ]}
      />

      <section className="fp-container-fluid solutions__c">
        <div className="fp-container">
          <div className="fp-row">
            <div className="cell-lg-4">
              <h2>How FurtherPass Works ?</h2>
            </div>
            <div className="cell-lg-4">
              <p>Our platform seamlessly integrates into your existing processes, streamlining operations and enhancing
                compliance. With biometric identification, digital document verification, and intelligent admissibility
                checks, FurtherPass simplifies the entire travel experience.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="fp-container-fluid solutions__s">
        <div className="fp-row">
          <div className="cell-lg-4 solution__blocks block-1">
            <div className="block--image block-1-image"></div>
            <div className="block--content block-1-content">
              <h2>
                Biometric Integration
              </h2>
              <p>Say farewell to physical passports and boarding passes. Our biometric technology ensures secure and
                efficient identification, reducing the need for manual checks.</p>
            </div>
          </div>
          <div className="cell-lg-4 solution__blocks block-2">
            <div className="block--image block-2-image"></div>
            <div className="block--content block-2-content">
              <h2>
                Document Verification
              </h2>
              <p>Our system validates various travel documents and visas, simplifying the often complex process.
              </p>
            </div>
          </div>
          <div className="cell-lg-4 solution__blocks block-3">
            <div className="block--image block-3-image"></div>
            <div className="block--content block-3-content">
              <h2>
                Admissibility Checks
              </h2>
              <p>FurtherPass calculates passenger admissibility based on nationality, document type, and destination
                country travel rules, ensuring compliance.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="fp-container-fluid solutions__demo">
        <div className="fp-container">
          <div className="fp-row">
            <div className="cell-12 cell-lg-10">
              <h3><b>Join the Revolution</b> Become part of the digital transformation. FurtherPass collaborates with
                airlines, startups, and industry leaders to shape the future of travel. Let's pioneer together.
              </h3>
              <p>Ready to experience the future of airline operations and passenger satisfaction? Request a demo and
                embark on a journey toward operational excellence with FurtherPass.</p>
            </div>
          </div>
          <div className="fp-row">
            <div className="cta">
              <a href={"/contact-us"} className="primary">
                Request a Demo
              </a>
              <a href={"/contact-us"}>
                Learn More
              </a>
            </div>
          </div>
          <div className="fp-row">
            <div className="cell-12 cell-lg-10">
              <p>At FurtherPass, we're committed to reshaping the aviation landscape, one passenger at a time. Join us
                on this transformative journey.
              </p>
            </div>
          </div>
        </div>
      </section>

      <NavbarFooter/>
    </>
  );
};

